import { useNotificationsStore } from '@/stores/notifications'

export const useAuthStore = defineStore('auth-store', () => {
    // const notifications_store = useNotificationsStore()
    const { makeNotification } = useNotificationsStore()

    //////////////////// ref()s become state properties
    // const authenticated = ref(false)
    const oneMonthInSeconds = 30 * 24 * 60 * 60 // 30 days in seconds
    const user_id = useCookie('user_id', { sameSite: true, maxAge: oneMonthInSeconds })
    const access_token = useCookie('access_token', { sameSite: true, maxAge: oneMonthInSeconds })
    const refresh_token = useCookie('refresh_token', { sameSite: true, maxAge: oneMonthInSeconds })
    const figma_user_id = useCookie('figma_user_id', { sameSite: true, maxAge: oneMonthInSeconds })

    //////////////////// computed()s become getters
    const is_authenticated = computed(() => (useCookie('access_token', { sameSite: true }).value ? true : false))
    const user_id_getter = computed(() => user_id.value)
    const access_token_getter = computed(() => access_token.value)
    const refresh_token_getter = computed(() => refresh_token.value)
    const figma_user_id_getter = computed(() => figma_user_id.value)

    function save_refresh_token(a, r) {
        access_token.value = a
        refresh_token.value = r
        makeNotification('Authentication refreshed')
    }

    //////////////////// function()s become actions
    async function user_login_with_email(username, password) {
        return new Promise((resolve, reject) => {
            const formdata = new FormData()
            formdata.append('username', username)
            formdata.append('password', password)

            req(':api:/token', 'POST', formdata)
                .then((response) => {
                    if (response.auth) {
                        access_token.value = response.access_token
                        refresh_token.value = response.refresh_token
                        user_id.value = response.user.id

                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    function request_google_oauth_code() {
        return new Promise((resolve, reject) => {
            req(':api:/get-google-oauth-link', 'GET')
                .then((response) => {
                    if (response) {
                        resolve(response)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    async function user_login_with_google(code) {
        return new Promise((resolve, reject) => {
            let url = ':api:/google-callback?code=' + encodeURIComponent(code)
            req(url, 'GET')
                .then((response) => {
                    console.log('DDDDDDDD', response)
                    if (response.auth) {
                        access_token.value = response.access_token
                        refresh_token.value = response.refresh_token
                        user_id.value = response.user.id
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    async function set_figma_user_id(id) {
        figma_user_id.value = id
        // return new Promise((resolve, reject) => {
        //   let url = ':api:/google-callback?code=' + encodeURIComponent(code);
        //   req(url, 'GET')
        //     .then((response) => {
        //       console.log('DDDDDDDD', response);
        //       if (response.auth) {
        //         access_token.value = response.access_token;
        //         refresh_token.value = response.refresh_token;
        //         user_id.value = response.user.id;
        //         resolve(response);
        //       } else {
        //         reject(response);
        //       }
        //     })
        //     .catch((err) => {
        //       reject(err);
        //     });
        // });
    }

    function user_logout() {
        access_token.value = null
        refresh_token.value = null
        user_id.value = null
        figma_user_id.value = null

        makeNotification('You have been logged out')
        navigateTo('/')
        return true
    }

    async function user_register_with_email(email, password, turnstileToken) {
        return new Promise((resolve, reject) => {
            const data = { email: email, password: password, captchaToken: turnstileToken }
            req(':api:/users', 'POST', data)
                .then((response) => {
                    console.log(response)
                    if (response.id) {
                        makeNotification('Welcome to Foldwrap!')
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    async function user_request_password_reset(for_email) {
        return new Promise((resolve, reject) => {
            const data = { for_email }
            req(':api:/user/password_forgot', 'POST', data)
                .then((response) => {
                    if (response) {
                        resolve(response)
                    } else {
                        reject(response.detail)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    async function user_password_reset(email, code, new_password) {
        return new Promise((resolve, reject) => {
            const data = { email, code, new_password }
            req(':api:/user/password_reset', 'POST', data)
                .then((response) => {
                    if (response) {
                        resolve(response)
                    } else {
                        reject(response.detail)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    async function user_confirm_email(confirmation_code) {
        return new Promise((resolve, reject) => {
            req(':api:/confirm?code=' + confirmation_code, 'GET')
                .then((response) => {
                    resolve(response)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    return {
        is_authenticated,
        user_id_getter,
        access_token_getter,
        refresh_token_getter,
        user_login_with_email,
        user_register_with_email,
        user_logout,
        user_request_password_reset,
        user_password_reset,
        user_confirm_email,
        request_google_oauth_code,
        user_login_with_google,
        save_refresh_token,
        figma_user_id_getter,
        set_figma_user_id,
    }
})
